import api from './api';

export interface LoginDto {
  email: string;
  password: string;
}

export interface RegisterDto {
  name: string;
  company: string;
  department: string;
  email: string;
  password: string;
}

export interface RegisterGoogleDto {
  idToken: string;
  name: string;
  company: string;
  department: string;
}

export interface GoogleProfile {
  email: string;
  name: string;
  picture?: string;
  googleId: string;
}

export interface GoogleLoginResponse {
  access_token?: string;
  user?: {
    id: number;
    email: string;
    role: string;
    picture?: string;
  };
  needsRegistration?: boolean;
  googleProfile?: GoogleProfile;
}

export interface AuthResponse {
  access_token: string;
  user: {
    id: number;
    email: string;
    role: string;
  };
}

export const authService = {
  login: async (data: LoginDto): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  googleLogin: async (idToken: string): Promise<GoogleLoginResponse> => {
    const response = await api.post<GoogleLoginResponse>('/auth/google', { idToken });
    return response.data;
  },

  register: async (data: RegisterDto): Promise<any> => {
    const response = await api.post('/users/register', data);
    return response.data;
  },

  registerGoogle: async (data: RegisterGoogleDto): Promise<any> => {
    const response = await api.post('/users/register-google', data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },

  getProfile: async (): Promise<any> => {
    const response = await api.get('/auth/profile');
    return response.data;
  },
};
